module.exports = __webpack_public_path__ + "img/mark_title.7074dc4e.png";